import { render, staticRenderFns } from "./activityNotification.vue?vue&type=template&id=92e0d36c&scoped=true"
import script from "./activityNotification.vue?vue&type=script&lang=js"
export * from "./activityNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e0d36c",
  null
  
)

export default component.exports